// Canonical AFM theme tokens. Used by both tenant-console
// and vendor-console so the platform looks the same regardless of
// which console the user is in.
//
// History: extracted 2026-04-29 from
// services/ui/tenant-console/src/contexts/ThemeContext.js so vendor
// console can adopt the same Silver/Gold + Dark Silver palette.

var GOLD_GRADIENT = 'linear-gradient(135deg, #c9a961 0%, #d4b76f 100%)';
export var themes = {
  'light-silver-gold': {
    name: 'Silver & Gold',
    mode: 'light',
    primary: '#c9a961',
    secondary: '#a8b5c4',
    background: '#f7f8fa',
    backgroundSecondary: '#eef0f3',
    sidebarGradient: 'linear-gradient(180deg, #f7f8fa 0%, #e8eaed 100%)',
    logoGradient: GOLD_GRADIENT,
    menuHover: 'linear-gradient(135deg, #e5e8eb 0%, #d8dce0 100%)',
    menuSelected: GOLD_GRADIENT,
    border: '#d1d5db',
    textPrimary: '#1f2937',
    textSecondary: '#4b5563',
    textIcon: '#6b7280',
    shadow: 'rgba(201, 169, 97, 0.12)',
    shadowStrong: 'rgba(201, 169, 97, 0.22)',
    contentBg: '#ffffff',
    headerBg: '#ffffff',
    // Aliases for the widely-used --theme-cardBg / --theme-text vars
    // (surface background + primary text). Without these the many
    // `var(--theme-cardBg, #fff)` / `var(--theme-text, #1f2937)` call
    // sites fall back to hard-coded light values and never go dark.
    cardBg: '#ffffff',
    text: '#1f2937'
  },
  'dark-silver': {
    name: 'Dark Silver',
    mode: 'dark',
    primary: '#c9a961',
    secondary: '#d6d6d6',
    background: '#2a2a2f',
    backgroundSecondary: '#35353a',
    sidebarGradient: 'linear-gradient(180deg, #2a2a2f 0%, #35353a 100%)',
    logoGradient: GOLD_GRADIENT,
    menuHover: 'linear-gradient(135deg, #3a3a42 0%, #4a4a52 100%)',
    menuSelected: GOLD_GRADIENT,
    border: '#4a4a52',
    textPrimary: '#f5f5f5',
    textSecondary: '#d6d6d6',
    textIcon: '#a8b5c4',
    shadow: 'rgba(201, 169, 97, 0.3)',
    shadowStrong: 'rgba(201, 169, 97, 0.5)',
    contentBg: '#1f1f24',
    headerBg: '#2a2a2f',
    // Dark-mode surface + text so --theme-cardBg / --theme-text call
    // sites resolve correctly instead of falling back to light values.
    cardBg: '#1f1f24',
    text: '#f5f5f5'
  }
};
export var DEFAULT_THEME_KEY = 'light-silver-gold';